export default "__VITE_ASSET__Bs3Ysa_f__"